import { postcodeValidator } from 'postcode-validator';

/**
 * Validates a postal code for a given country code
 * @param {string} postalCode - The postal code to validate
 * @param {string} countryCode - The ISO country code (e.g., 'US', 'CA', 'GB')
 * @returns {boolean} - Returns true if the postal code is valid for the given country
 */
export const validatePostalCode = (postalCode, countryCode) => {
  if (!postalCode || !countryCode) {
    return false;
  }

  return postcodeValidator(postalCode, countryCode);
};

/**
 * Creates a validator function for use with Ant Design Form validation
 * @param {string} countryCode - The ISO country code
 * @returns {Function} - A validator function that returns a Promise
 */
export const postalCodeValidator = countryCode => (_, value) => {
  if (!value || validatePostalCode(value, countryCode)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error('Invalid postal code'));
};
